import React from 'react';
import { ScrollView, StyleSheet, useWindowDimensions, View } from 'react-native';
import { PromptText } from '../components/PromptText';
import { ContentView } from '../components/ContentView';
import { FittedLogo } from '../components/FittedLogo';
import { SidePanel, SIDE_PANEL_WIDTH } from '../components/SidePanel';
import { theme } from '../theme';
import { isWideLayoutWidth } from '../utils/useIsNarrowWindow';
const WELCOME = "Welcome to Abbi's Way\n\nPlease sign in";
export const SigninScreen = () => {
    const { width } = useWindowDimensions();
    if (!isWideLayoutWidth(width)) {
        // Phone and mid-size windows (< WIDE_LAYOUT_WIDTH): one column (wordmark
        // and welcome on top, then the form). Side by side only when the pane
        // beside the 300px panel has room for the desktop banner.
        return (<ContentView>
        <ScrollView style={styles.narrowScroll} contentContainerStyle={styles.narrowContent} keyboardShouldPersistTaps="handled">
          <View style={styles.narrowHero}>
            <FittedLogo variant="wordmark"/>
            <PromptText prompt={WELCOME} style={styles.narrowWelcome}/>
          </View>
          <View style={styles.narrowForm}>
            <SidePanel fullWidth/>
          </View>
        </ScrollView>
      </ContentView>);
    }
    return (<ContentView>
      <View style={styles.container}>
        <SidePanel />
        <View style={styles.content}>
          <FittedLogo availableWidth={width - SIDE_PANEL_WIDTH} style={styles.logo}/>
          <PromptText prompt={WELCOME}/>
        </View>
      </View>
    </ContentView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    logo: {
        marginTop: 50,
    },
    content: {
        flex: 1,
        minWidth: 0,
        backgroundColor: theme.colors.backgroundSignInWeb,
    },
    narrowScroll: {
        flex: 1,
        backgroundColor: theme.colors.backgroundSignInWeb,
    },
    narrowContent: {
        flexGrow: 1,
    },
    narrowHero: {
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingBottom: 20,
    },
    narrowWelcome: {
        marginTop: 16,
        fontSize: 22,
        lineHeight: 28,
    },
    /** Mid-size windows: keep the stacked form a readable width, centered. */
    narrowForm: {
        flexGrow: 1,
        width: '100%',
        maxWidth: 560,
        alignSelf: 'center',
    },
});
